(function () {
  'use strict';

  if (window.__pollyYampiFailClosedInstalled) return;
  window.__pollyYampiFailClosedInstalled = true;

  var CHECKOUT_LINK_SELECTOR = [
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    'a[href="/a/checkout"]',
    '[data-yampi-checkout="true"]',
    '.cart__checkout-btn[name="checkout"]'
  ].join(',');

  var CHECKOUT_FORM_SELECTOR = [
    'form[action="/checkout"]',
    '[data-yampi-checkout-form="true"]'
  ].join(',');

  var waiting = false;
  var navigating = false;
  var retryTimer = null;

  function isCartPage() {
    return window.location.pathname === '/cart' ||
      (document.body && document.body.classList.contains('template-cart'));
  }

  function resolvedYampiUrl() {
    var url = window.yampiCheckoutUrl || '';
    if (!url) return '';

    try {
      if (typeof window.ymp_getUrlWithUtms === 'function') {
        return window.ymp_getUrlWithUtms(url) || url;
      }
    } catch (error) {}

    return url;
  }

  function showLoader() {
    var el = document.querySelector('.yampi-loader');
    if (el) el.style.display = 'block';
  }

  function hideLoader() {
    var el = document.querySelector('.yampi-loader');
    if (el) el.style.display = 'none';
  }

  function ensureMessageBox() {
    var box = document.getElementById('polly-yampi-checkout-error');
    if (box) return box;

    box = document.createElement('div');
    box.id = 'polly-yampi-checkout-error';
    box.setAttribute('role', 'alert');
    box.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:22px',
      'transform:translateX(-50%)',
      'z-index:2147483647',
      'max-width:calc(100vw - 28px)',
      'width:460px',
      'box-sizing:border-box',
      'padding:14px 16px',
      'border-radius:10px',
      'background:#fff',
      'color:#222',
      'box-shadow:0 10px 35px rgba(0,0,0,.22)',
      'font-size:14px',
      'line-height:1.4',
      'display:none',
      'text-align:center'
    ].join(';');
    box.innerHTML = '<strong>Não foi possível abrir o pagamento.</strong><br>Tente novamente em alguns segundos. Seu carrinho continua salvo.';
    document.body.appendChild(box);
    return box;
  }

  function showError() {
    hideLoader();
    var box = ensureMessageBox();
    box.style.display = 'block';
    window.setTimeout(function () {
      box.style.display = 'none';
    }, 7000);
  }

  function goToYampi() {
    var url = resolvedYampiUrl();
    if (!url) return false;

    navigating = true;
    waiting = false;
    if (retryTimer) {
      clearInterval(retryTimer);
      retryTimer = null;
    }

    window.location.href = url;
    return true;
  }

  function triggerYampiGeneration() {
    try {
      if (typeof window.getNewCheckoutURL === 'function') {
        window.getNewCheckoutURL();
        return true;
      }
    } catch (error) {
      console.warn('[Polly/Yampi] Falha ao solicitar URL de checkout.', error);
    }
    return false;
  }

  function waitForYampi() {
    if (waiting || navigating) return;

    waiting = true;
    showLoader();
    triggerYampiGeneration();

    var startedAt = Date.now();
    retryTimer = window.setInterval(function () {
      if (goToYampi()) return;

      if (Date.now() - startedAt >= 10000) {
        clearInterval(retryTimer);
        retryTimer = null;
        waiting = false;
        showError();
      }
    }, 150);
  }

  async function promoAllowsCheckout() {
    try {
      if (
        window.Polly4x3CheckoutGuard &&
        typeof window.Polly4x3CheckoutGuard.enforce === 'function'
      ) {
        return await window.Polly4x3CheckoutGuard.enforce();
      }
    } catch (error) {
      console.warn('[Polly/Yampi] Não foi possível validar a promoção antes do checkout.', error);
    }
    return true;
  }

  async function handleCheckout(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    if (navigating) return;

    var allowed = await promoAllowsCheckout();
    if (!allowed) {
      hideLoader();
      return;
    }

    if (!isCartPage()) {
      window.location.href = '/cart?ref=yampi_checkout';
      return;
    }

    if (!goToYampi()) {
      waitForYampi();
    }
  }

  function hardenNativeCheckoutTargets(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('a[href="/checkout"], a[href^="/checkout?"], a[href="/a/checkout"]').forEach(function (link) {
      if (!link.dataset.yampiOriginalHref) {
        link.dataset.yampiOriginalHref = link.getAttribute('href') || '';
      }
      link.setAttribute('href', '/cart');
      link.setAttribute('data-yampi-checkout', 'true');
      link.setAttribute('data-native-checkout-blocked', 'true');
    });

    scope.querySelectorAll('form[action="/checkout"]').forEach(function (form) {
      if (!form.dataset.yampiOriginalAction) {
        form.dataset.yampiOriginalAction = form.getAttribute('action') || '';
      }
      form.setAttribute('action', '/cart');
      form.setAttribute('data-yampi-checkout-form', 'true');
      form.setAttribute('data-native-checkout-blocked', 'true');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest(CHECKOUT_LINK_SELECTOR)
      : null;

    if (!target) return;
    handleCheckout(event);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;

    var submitter = event.submitter;
    var isCheckout =
      form.matches(CHECKOUT_FORM_SELECTOR) ||
      (submitter && submitter.name === 'checkout');

    if (!isCheckout) return;
    handleCheckout(event);
  }, true);

  function start() {
    hardenNativeCheckoutTargets(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) {
            if (node.matches && (
              node.matches('a[href="/checkout"], a[href^="/checkout?"], a[href="/a/checkout"], form[action="/checkout"]')
            )) {
              hardenNativeCheckoutTargets(node.parentNode || document);
            } else if (node.querySelectorAll) {
              hardenNativeCheckoutTargets(node);
            }
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();